const STUDY_SUMMARY_TYPES = {
  SURVEYS: {
    key: 'SURVEYS',
  },
  QRE: {
    key: 'QRE',
  },
  SEASON: {
    key: 'SEASON',
  },
};

export default STUDY_SUMMARY_TYPES;
